export const FETCH_PROJECTS_START = "FETCH_PROJECTS_START";
export const FETCH_PROJECTS_FAIL = "FETCH_PROJECTS_FAIL";
export const FETCH_PROJECTS_SUCCESS = "FETCH_PROJECTS_SUCCESS";

export const PROJECT_CLICKED = "PROJECT_CLICKED";

export const FETCH_PARTICULAR_PROJECT_START = "FETCH_PARTICULAR_PROJECT_START";
export const FETCH_PARTICULAR_PROJECT_SUCCESS = "FETCH_PARTICULAR_PROJECT_SUCCESS";
export const FETCH_PARTICULAR_PROJECT_FAIL = "FETCH_PARTICULAR_PROJECT_FAIL";

export const FETCH_PARTICULAR_PROJECT_ON_PAGE_LOAD_FAIL = "FETCH_PARTICULAR_PROJECT_ON_PAGE_LOAD_FAIL";

export const FETCHED_PROJECT_NOT_FOUND = "FETCHED_PROJECT_NOT_FOUND";